export enum SELECTOR_MODES {
  NEUTRAL,
  SPOT,
  FORWARD_CURVE
}

export type ConflictingMode = SELECTOR_MODES.SPOT | SELECTOR_MODES.FORWARD_CURVE;

export const MODE_CONFLICT_MESSAGES: Record<ConflictingMode, string> = {
  [SELECTOR_MODES.SPOT]: 'You have spot data in your selector. Clear selection first.',
  [SELECTOR_MODES.FORWARD_CURVE]:
    'You have forward curve data in your selector. Clear selection first.'
};
